import { EndPoints } from '../../common/enums/enums';
import { api } from './api';

export const vendorsServices = api.injectEndpoints({
  endpoints: build => ({
    getVendors: build.query({
      query: companyId =>
        EndPoints.ORDERS.NEW_ORDER.GET_VENDORS.ENDPOINT.replace(
          '{companyId}',
          companyId
        ),
      transformResponse: response => response.vendors,
    }),
    statusUpdate: build.mutation({
      query: body => ({
        url: `${EndPoints.ORDERS.RECON_STATUS.ENDPOINT}`,
        method: `${EndPoints.ORDERS.RECON_STATUS.METHOD}`,
        body,
      }),
    }),
    getVehiclePhotoCount: build.mutation({
      query: ({ body, vinOrStockNumber }) => ({
        url: EndPoints.ORDERS.GET_VEHICLE_PHOTOCOUNT.ENDPOINT.replace(
          '{vinOrStockNumber}',
          vinOrStockNumber
        ),
        method: EndPoints.ORDERS.GET_VEHICLE_PHOTOCOUNT.TYPE,
        body,
      }),
    }),
    getFrontLineVehiclesList: build.query({
      query: ({ companyId, searchTerm }) => ({
        url: EndPoints.ORDERS.NEW_ORDER.GET_FRONTLINE_VEHICLE_LIST.ENDPOINT.replace(
          '{companyId}',
          companyId
        ).replace('{searchTerm}', searchTerm),
        method: EndPoints.ORDERS.NEW_ORDER.GET_FRONTLINE_VEHICLE_LIST.TYPE,
      }),
    }),
    getDealersByCompany: build.query({
      query: companyId =>
        EndPoints.ORDERS.DEALERS.GET.ENDPOINT.replace('{companyId}', companyId),
      transformResponse: response => response.dealers,
    }),
  }),
});

export const {
  useGetVendorsQuery,
  useStatusUpdateMutation,
  useGetVehiclePhotoCountMutation,
  useLazyGetFrontLineVehiclesListQuery,
  useGetDealersByCompanyQuery,
} = vendorsServices;
